enum Locale {
    FR = 'fr',
    AR = 'ar',
}

export default Locale;
